// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import KeyIcon from '@mui/icons-material/Key';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useParties } from '../../contexts/PartiesContext';
import { DeadTasks } from '../../pages/DeadTasks';
import { UnresponsiveParties } from '../../pages/UnresponsiveParties/UnresponsiveParties';
import { Billing } from '../../pages/credentials/Billing';
import { Credentials } from '../../pages/credentials/Credentials';
import { Offers } from '../../pages/credentials/Offers';
import { Onboarding } from '../../pages/credentials/Onboarding';
import { ModuleRoute } from '../../routes/types';
import { UtilityBackend } from '../../utils/UtilityAutomationApiClient';
import useUserService from '../queries/credential/onboarding/useUserService';

export const useCredentialEntries = () => {
  const sidebarEntries: ModuleRoute[] = [
    {
      label: 'Onboarding',
      path: 'onboarding',
      element: <Onboarding />,
      icon: <AdminPanelSettingsIcon fontSize="small" />,
    },
  ];

  const onboardedEntries: ModuleRoute[] = [
    {
      icon: <KeyIcon fontSize="small" />,
      label: 'Credentials',
      path: 'credentials',
      element: <Credentials />,
    },
    {
      label: 'Offers',
      path: 'offers',
      element: <Offers />,
      icon: <PlaylistAddCheckIcon fontSize="small" />,
    },
    {
      label: 'Billing',
      path: 'billing',
      element: <Billing />,
      icon: <MonetizationOnIcon fontSize="small" />,
    },
  ];

  const operatorEntries: ModuleRoute[] = [
    {
      label: 'Dead Tasks',
      path: 'dead-tasks',
      icon: <DeleteSweepIcon fontSize="small" />,
      element: <DeadTasks backend={UtilityBackend.CREDENTIAL} />,
    },
    {
      label: 'Unresponsive parties',
      path: 'unresponsive-parties',
      icon: <NoAccountsIcon fontSize="small" />,
      element: <UnresponsiveParties disableVirtualization backend={UtilityBackend.CREDENTIAL} />,
    },
  ];

  const { operator, party } = useParties();
  const isOperator = operator === party;
  const userService = useUserService();
  let entries =
    userService.isSuccess && !!userService.data
      ? sidebarEntries.concat(onboardedEntries)
      : sidebarEntries;
  if (isOperator) {
    entries = entries.concat(operatorEntries);
  }

  return entries;
};
